import { ChangeDetectionStrategy, Component } from '@angular/core';
import { LoginNavService } from 'src/app/shared/login.nav-service';
import { LoginModule } from '@cevi/cevi-ui-library/login';

@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrl: './login.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [LoginModule],
})
export class LoginComponent { 

  constructor(private loginNavService: LoginNavService ){}

  public doFasEid =() =>{
    this.loginNavService.gotoAuthentication('FAS', 'Eid');
  }
  public doFasItsme =() =>{
    this.loginNavService.gotoAuthentication("FAS", "ItsMe");
  }
  public doAad=()=>{
    this.loginNavService.gotoAuthentication("AAD", "");
  }

}
